import { useState } from 'react'
import { Check, Copy } from 'lucide-react'

export function CopyButton({ value, label = 'Copy' }: { value: string; label?: string }) {
  const [copied, setCopied] = useState(false)
  return (
    <button
      type="button"
      className="btn btn-secondary !px-3 !py-1.5 text-sm"
      onClick={async () => {
        try {
          await navigator.clipboard.writeText(value)
          setCopied(true)
          setTimeout(() => setCopied(false), 1500)
        } catch {
          // clipboard blocked: the value is still visible to select by hand
        }
      }}
    >
      {/* both labels share one cell, so the button keeps its width while it says "Copied" (John, Oct 31 2026) */}
      <span className="grid">
        <span className={`col-start-1 row-start-1 flex items-center justify-center gap-2 ${copied ? '' : 'invisible'}`} aria-hidden={!copied}>
          <Check className="size-4 text-accent" /> Copied
        </span>
        <span className={`col-start-1 row-start-1 flex items-center justify-center gap-2 ${copied ? 'invisible' : ''}`} aria-hidden={copied}>
          <Copy className="size-4" /> {label}
        </span>
      </span>
    </button>
  )
}
